
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ROICalculatorSection() {
  const [setupTime, setSetupTime] = useState(80);
  const [machineRate, setMachineRate] = useState(4000);
  const [defectCost, setDefectCost] = useState(600000);
  const [toolCost, setToolCost] = useState(150000);
  const [investment, setInvestment] = useState(8000000);

  const calculateROI = () => {
    const setupSavings = setupTime * machineRate;
    const totalMonthlySavings = setupSavings + defectCost + toolCost;
    const paybackMonths = Math.ceil(investment / totalMonthlySavings);
    
    return {
      setupSavings,
      totalMonthlySavings,
      paybackMonths
    };
  };

  const { setupSavings, totalMonthlySavings, paybackMonths } = calculateROI();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            費用対効果を"自社値"で見える化
          </h2>
          <p className="text-xl text-gray-600">簡易ROIシミュレーター</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">パラメータ設定</h3>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  短縮時間（h/月）
                </label>
                <input
                  type="number"
                  value={setupTime}
                  onChange={(e) => setSetupTime(Number(e.target.value))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  機械チャージ（円/h）
                </label>
                <input
                  type="number"
                  value={machineRate}
                  onChange={(e) => setMachineRate(Number(e.target.value))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  不良費削減（円/月）
                </label>
                <input
                  type="number"
                  value={defectCost}
                  onChange={(e) => setDefectCost(Number(e.target.value))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  工具費削減（円/月）
                </label>
                <input
                  type="number"
                  value={toolCost}
                  onChange={(e) => setToolCost(Number(e.target.value))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  導入総額（円）
                </label>
                <input
                  type="number"
                  value={investment}
                  onChange={(e) => setInvestment(Number(e.target.value))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>
          
          <div className="bg-yellow-400 p-8 rounded-xl">
            <h3 className="text-2xl font-bold text-black mb-6">ROI計算結果</h3>
            
            <div className="space-y-6">
              <div className="bg-white/20 p-4 rounded-lg">
                <div className="text-sm text-black/80 mb-1">段取り短縮効果</div>
                <div className="text-2xl font-bold text-black">
                  ¥{setupSavings.toLocaleString()}/月
                </div>
              </div>
              
              <div className="bg-white/20 p-4 rounded-lg">
                <div className="text-sm text-black/80 mb-1">月間キャッシュイン合計</div>
                <div className="text-3xl font-bold text-black">
                  ¥{totalMonthlySavings.toLocaleString()}/月
                </div>
              </div>
              
              <div className="bg-black p-4 rounded-lg">
                <div className="text-sm text-white/80 mb-1">投資回収期間</div>
                <div className="text-3xl font-bold text-white">
                  約{paybackMonths}か月
                </div>
              </div>
              
              <div className="bg-white/20 p-4 rounded-lg">
                <div className="text-sm text-black/80 mb-2">回収後の利益</div>
                <div className="text-lg font-bold text-black">
                  {paybackMonths + 1}ヶ月目以降は、毎月{Math.round(totalMonthlySavings/10000)}万円が、20年間にわたり手に入る!!
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <Button variant="primary" size="lg" onClick={scrollToContact}>
            <i className="ri-calculator-line mr-2"></i>
            30秒で入力：あなたのROIを自動計算
          </Button>
        </div>
      </div>
    </section>
  );
}
